import Button from "../button";
import BaseModal from "./base/BaseModal";

export default function NoticeModal({ close }: ModalComponentProps) {
  return (
    // BaseModal의 너비를 설정합니다.
    <BaseModal size={"fitheight"} close={close} className="w-full max-w-lg">
      <div className="flex flex-col max-h-[80vh]">
        <div className="overflow-y-auto p-6 sm:p-8">
          <div className="text-center mb-8 pb-4 border-b-2 border-gray-200">
            <p className="text-sm font-semibold text-blue-600">KPPGA PROTEST</p>
            <h2 className="text-2xl font-bold text-gray-800 mt-1">
              프로테스트 안내
            </h2>
          </div>

          {/* 안내 내용 */}
          <div className="space-y-6 text-base">
            {/* ... (기존 안내 내용은 그대로) ... */}
            <div className="space-y-4">
              <div>
                <h3 className="font-bold text-lg text-gray-700 mb-2">
                  ■ 오전 참가자
                </h3>
                <ul className="list-disc list-outside ml-6 text-gray-600 space-y-1">
                  <li>
                    <span className="font-semibold">등록 시간:</span> 07:30 ~
                    08:20
                  </li>
                  <li>
                    <span className="font-semibold">경기 시작:</span> 09:00
                  </li>
                </ul>
              </div>
              <div>
                <h3 className="font-bold text-lg text-gray-700 mb-2">
                  ■ 오후 참가자
                </h3>
                <ul className="list-disc list-outside ml-6 text-gray-600 space-y-1">
                  <li>
                    <span className="font-semibold">등록 시간:</span> 12:00 ~
                    12:50
                  </li>
                  <li>
                    <span className="font-semibold">경기 시작:</span> 13:30
                  </li>
                </ul>
              </div>
            </div>
            <hr className="border-gray-200" />
            <div className="space-y-4">
              <div>
                <h3 className="font-bold text-lg text-gray-700 mb-2">
                  ■ 경기 방식
                </h3>
                <p className="ml-6 text-gray-600">샷건(Shotgun) 방식</p>
              </div>
              <div>
                <h3 className="font-bold text-lg text-gray-700 mb-2">
                  ■ 경기 종료 후
                </h3>
                <p className="ml-6 text-gray-600">점수 확인 후 귀가</p>
              </div>
              <div>
                <h3 className="font-bold text-lg text-gray-700 mb-2">
                  ■ 필수 지참물
                </h3>
                <ul className="list-disc list-outside ml-6 text-gray-600 space-y-1">
                  <li>신분증</li>
                  <li>파크골프채</li>
                  <li>공</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* 3. 하단에 고정될 닫기 버튼 영역입니다. */}
        <div className="w-full p-4 flex-shrink-0">
          <Button
            className="w-full text-lg py-3"
            variant={"black"}
            label="닫기"
            onClick={close}
          />
        </div>
      </div>
    </BaseModal>
  );
}
